import React from "react";
import { createContext, useState } from "react";
import { useSelector } from "react-redux";
import { createBrowserRouter } from "react-router-dom";
import { AfterLoginRoutes, ProtectedRouters, publicRoutes } from "./router";

export const RouterContext = createContext()

export const RoutersProvider = ({ children }) => {

const { token,currentUser } = useSelector((state) => state.store);
let roleId;
let permissions;
console.log("RouterContext: ", currentUser?.data?.permissions);
if (currentUser?.data?.user) {
  roleId = currentUser?.data?.user?.user_role?.role_id;
  permissions = currentUser?.data?.permissions;
  // console.log("permissions`", permissions);
}

const roleBasedRouter = (routes) => {
  if (roleId === 1) return routes;
  if (routes) {
    const r = routes.filter((route) =>
      // permissions?.filter((d)=>d.roleId.role_id===roleId).some((p)=>{
      permissions?.some((p) => {
        if (p.component.name === route?.meta?.name) {
          p?.permissions?.some((pr) => pr.permissionName === "Read") &&
            route.element?.props?.meta?.push(p);
          // console.log("permissionssss", p);
          p?.permissions?.some((pr) => pr.permissionName === "Read") &&
            route.element?.props?.meta?.push(p);

          return p?.permissions.some((pr) => pr.permissionName === "Read");
        } else {
          return false;
        }
      })
    );
    // console.log("r=========>", r);
    return r;
  }

  return routes;
};

const fileteredRotues=roleBasedRouter(AfterLoginRoutes);
ProtectedRouters.children=fileteredRotues

const router = createBrowserRouter([...publicRoutes,ProtectedRouters]);
   
    // Action jaisa hai @end
    return (
        <RouterContext.Provider
            value={{
                // Router
                router,  
                fileteredRotues              
            }}
        >
            {children}
        </RouterContext.Provider>
    )
}


export default RouterContext